import Panel from './Panel.js';

/**
 * Popin Newsletter class.
 */
export default class PanelSize extends Panel {
  maxDistance = 100;

  static config = {
    name: 'PanelSize',
    refs: ['content', ...Panel.config.refs],
    options: {
      url: {
        default: '',
        type: String,
      },
    },
  };

  /**
   *
   */
  openPanel() {
    fetch(this.$options.url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const contentSizeGuide = html.querySelector(`#content`);
        this.$refs.content.innerHTML = contentSizeGuide.innerHTML;
        super.openPanel();
      });
  }
}
